import React from 'react';
function Question({ question, options, questionIndex, onOptionChange,img }) {
    return (
        <div className="question">
          <img className="img-fluid" src={img} alt="This is an Anime poster"/>
            <p>{question}</p>
            {Object.keys(options).map((key) => (
                <label key={key}>
                    <input
                        type="radio"
                        name={`question${questionIndex}`}
                        value={key}
                        onChange={() => onOptionChange(questionIndex, key)}
                    />
                     {options[key]}
                </label>
            ))}
        </div>
    );
}
export default Question;
